module.exports = __webpack_public_path__ + "img/2015-12_bloomberg.a7358991.jpg";